import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationServicePut = {
    path: "/template/service",
    method: ERouteHttpVerb.PUT
};
export { routeLocationServicePut };
